import { createContext, useContext } from 'react';

export const ShadowRootContext = createContext<ShadowRoot | null>(null);

export function ShadowRootProvider({
  shadowRoot,
  children,
}: {
  shadowRoot: ShadowRoot | null;
  children: React.ReactNode;
}) {
  return <ShadowRootContext.Provider value={shadowRoot}>{children}</ShadowRootContext.Provider>;
}

export function useShadowRoot(): ShadowRoot | null {
  return useContext(ShadowRootContext);
}
